/**
 * Copyright 2023-2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { PlanActionType } from "~/generated/graphql";
import { createCtx } from "~/tools";
import {
  NotificationGroupItem,
  SelectedPlanEntity,
  TimeUnits,
} from "../PlanCreate/components/PlanCreateWizard/types";
import { BatchActionData, PlanActionData, PlanData } from "./types";

type PlanAction = NonNullable<SelectedPlanEntity["action"]> & {
  version?: string;
};

export type PlanExtended = Omit<PlanData, "planAction"> & {
  planAction?: SelectedPlanEntity;
};

export type PlanActionTypeExtended = SelectedPlanEntity & {
  resourceGroups?:
    | PlanActionData["resourceGroups"]
    | BatchActionData["resourceGroups"];
  resources?: PlanActionData["resources"] | BatchActionData["resources"];
  action?: PlanAction;
  actionType?: PlanActionType;
  resourceGroupIds?: string[];
  resourcesIds?: string[];
  notificationGroups?: NotificationGroupItem[] | null;
  unit?: TimeUnits;
  color?: string;
  order?: number;
};

type Props = {
  plan?: Partial<PlanExtended>;
  planAction?: PlanActionTypeExtended;
  setPlanAction?: (planAction?: PlanActionTypeExtended) => void;
  refetch?: () => void;
};

export const [usePlan, PlanCtxProvider] = createCtx<Props>();
